import { SPORTRADAR_TEAM_IDS } from '~/constants/SPORTRADAR_TEAM_IDS';

export const isValidSportradar = (
  customVertical: string,
  customTopic: string
): string | number | boolean => {
  if (!customVertical || !customTopic) {
    return false;
  }
  const vertical = customVertical.toLowerCase();
  const topic = customTopic.toLowerCase().replace(/ /g, '-');
  const validVertical =
    vertical in SPORTRADAR_TEAM_IDS || vertical.includes('ncaa');

  if (!validVertical) {
    return false;
  }

  // TODO: this will only work for the FanSided network
  if (vertical.includes('ncaa')) {
    return (
      topic in SPORTRADAR_TEAM_IDS.ncaaf || topic in SPORTRADAR_TEAM_IDS.ncaab
    );
  }

  return topic in SPORTRADAR_TEAM_IDS[vertical];
};
